/* eslint-disable no-await-in-loop */
import * as types from "./actionTypes";
import API from "../../services/ClientLedgerService";
import { apiCallError, beginApiCall } from "./apiStatusActions";

export const loadClientLedgerSuccess = clientLedger => ({ type: types.LOAD_CLIENT_LEDGER_SUCCESS, clientLedger });
export const createClientLedgerSuccess = clientLedgerEntry => ({ type: types.CREATE_CLIENT_LEDGER_SUCCESS, clientLedgerEntry });
export const updateClientLedgerSuccess = clientLedgerEntry => ({ type: types.UPDATE_CLIENT_LEDGER_SUCCESS, clientLedgerEntry });
export const deleteClientLedgerOptimistic = clientLedgerEntry => ({ type: types.DELETE_CLIENT_LEDGER_OPTIMISTIC, clientLedgerEntry });
const authScope = getState => JSON.stringify(getState().user || {});

let billingRequestId = 0;
export const billingScopeKey = (schoolId, clientId, year) => JSON.stringify([schoolId || null, clientId, year === undefined ? 'all' : year]);
export function loadClientBillingView(clientId, year) {
  return async (dispatch, getState) => {
    const scopeKey = billingScopeKey(getState().user.schoolId, clientId, year);
    const requestId = ++billingRequestId;
    dispatch({ type: 'BILLING_VIEW_BEGIN', scopeKey, requestId });
    try {
      // A revision check brackets the ledger read so the list and totals agree.
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const before = await API.getSummary(clientId);
        const entries = await API.getClientLedger(clientId, before.assignmentStatus === 'ready' ? year : undefined);
        const summary = await API.getSummary(clientId);
        if (before.revision === summary.revision && before.assignmentStatus === summary.assignmentStatus) {
          dispatch({ type: 'BILLING_VIEW_LOADED', scopeKey, requestId, entries, summary });
          return;
        }
      }
      throw new Error('BILLING_REVISION_CONFLICT');
    } catch (error) {
      dispatch({ type: 'BILLING_VIEW_ERROR', scopeKey, requestId, error: error.message });
      throw error;
    }
  };
}

export function loadClientLedger(clientId = "") {
  return (dispatch, getState) => {
    const scope = authScope(getState);
    dispatch(beginApiCall("getClientLedger"));
    return API.getClientLedger(clientId)
      .then(clientLedger => {
        dispatch(scope === authScope(getState) ? loadClientLedgerSuccess(clientLedger) : { type: 'BILLING_IGNORED_SUCCESS' });
        return clientLedger;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveClientLedgerEntry(clientLedgerEntry, isNew = false) {
  return (dispatch, getState) => {
    const scope = authScope(getState);
    dispatch(beginApiCall("saveClientLedgerEntry"));
    return API.saveClientLedgerEntry(clientLedgerEntry, isNew)
      .then(savedEntry => {
        const action = isNew ? createClientLedgerSuccess(savedEntry) : updateClientLedgerSuccess(savedEntry);
        dispatch(scope === authScope(getState) ? action : { type: 'BILLING_IGNORED_SUCCESS' });
        return savedEntry;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function deleteClientLedgerEntry(clientLedgerEntry) {
  return (dispatch, getState) => {
    const scope = authScope(getState);
    dispatch(beginApiCall("deleteClientLedgerEntry"));
    return API.deleteClientLedgerEntry(clientLedgerEntry)
      .then(() => {
        if (scope === authScope(getState)) dispatch(deleteClientLedgerOptimistic(clientLedgerEntry));
        dispatch({ type: 'BILLING_DELETE_SUCCESS' });
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function replaceMonthlyCharge(existingEntry, newEntry) {
  return dispatch => (
    dispatch(saveClientLedgerEntry(
      existingEntry
        ? { ...newEntry, id: existingEntry.id, entryKey: existingEntry.entryKey, expectedRevision: existingEntry.expectedRevision }
        : newEntry,
      !existingEntry,
    ))
  );
}
